/* eslint-disable */

import { useState } from "react";

// react-router components
import { Link, NavLink, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";

import logo from "assets/images/white-logo.png";
import routes from "routes";

// Material Dashboard 2 React context
function DashboardNavbar({ absolute, light, isMini }) {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const navigationRoutes = routes.filter((route) => route.type === "collapse" && route.route);

  const handleLogout = () => {
    sessionStorage.clear();
    setOpenMenu(false);
    navigate("/sign-in");
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#067332",
        borderRadius: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        minHeight="74px"
        px={{ xs: 1, sm: 3 }}
        gap={2}
      >
        <MDBox component={Link} to="/" display="flex" alignItems="center" flexShrink={0}>
          <MDBox component="img" src={logo} alt="Saudi Banks Joint Reception" width={{ xs: 120, sm: 170 }} />
        </MDBox>
        {/* <MDBox
          component="nav"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={{ xs: 0.5, md: 1, lg: 2 }}
          flex={1}
          sx={{ overflowX: "auto", minWidth: 0, "&::-webkit-scrollbar": { display: "none" } }}
        >
          {navigationRoutes.map(({ key, name, route }) => (
            <MDBox key={key} component={NavLink} to={route} sx={({ palette, typography }) => ({
              color: palette.white.main,
              fontSize: typography.size.sm,
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.72,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              "&.active, &:hover": { opacity: 1, backgroundColor: "rgba(255,255,255,0.12)" },
            })}>
              {name}
            </MDBox>
          ))}
        </MDBox> */}
        <IconButton aria-label="Open user menu" onClick={(event) => setOpenMenu(event.currentTarget)} sx={{ p: 0.5, flexShrink: 0 }}>
          <MDAvatar bgColor="secondary" size="md">
            <Icon fontSize="small" sx={{ color: "white.main" }}>person</Icon>
          </MDAvatar>
        </IconButton>
        <Menu
          anchorEl={openMenu}
          open={Boolean(openMenu)}
          onClose={() => setOpenMenu(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ mt: 1 }}
        >
          <MenuItem onClick={handleLogout}>
            <Icon fontSize="small" sx={{ mr: 1 }}>logout</Icon>
            Logout
          </MenuItem>
        </Menu>
      </MDBox>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
